exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._201ykWwx3JLD0jIwXOUB0K{width:100%;height:100%;text-align:center}.vVfwAvHhaFErka1X0Qr8n{line-height:50px;text-align:left;padding:10px;font-size:20px}.vVfwAvHhaFErka1X0Qr8n a,.vVfwAvHhaFErka1X0Qr8n a:hover{color:#000}.vVfwAvHhaFErka1X0Qr8n img{width:50px;vertical-align:middle;margin-right:10px}@media (max-height:900px){.vVfwAvHhaFErka1X0Qr8n{line-height:30px;text-align:left;padding:10px;font-size:18px}.vVfwAvHhaFErka1X0Qr8n img{width:30px;vertical-align:middle;margin-right:10px}}", ""]);

// exports
exports.locals = {
	"container": "_201ykWwx3JLD0jIwXOUB0K",
	"logo": "vVfwAvHhaFErka1X0Qr8n"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"module":true,"minimize":true}!./src/routes/app/comp.App.module.css
// module id = 240
// module chunks = 4